const settings = {
	production: process.env.NODE_ENV === 'production',
	basePath: process.env.NODE_ENV === 'production' ? 'https://office.deluxenetworkprogram.com' : 'http://localhost:5002',
	baseUIUrl: process.env.NODE_ENV === 'production' ? 'https://office.deluxenetworkprogram.com' : 'http://localhost:5002',
};

export default settings;